// Global
import React from 'react';

export const ProductHeroDecor = () => {
  return <></>;
};
